export default {
  setItens(state, payload) {
    state.itens = payload;
  },
  setDialog(state, payload) {
    state.dialog = payload;
  },
  setItem(state, payload) {
    state.item = payload;
  },
  setNews(state, payload) {
    state.news = payload;
  }
  // setEnviar(state, payload) {
  //   state.enviar = payload;
  // }
};
